import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBillingVisa = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 128,
	height: 86,
	viewBox: "0 0 128 86",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0 12C0 5.37258 5.37258 0 12 0H116C122.627 0 128 5.37258 128 12V74C128 80.6274 122.627 86 116 86H12C5.37258 86 0 80.6274 0 74V12Z",
			fill: "url(#paint0_linear_3_3876)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M65.6479 37.9105C65.5931 42.2288 69.4962 44.6386 72.4365 46.0713C75.4575 47.5415 76.4722 48.4841 76.4607 49.7986C76.4376 51.8107 74.0508 52.6985 71.8167 52.7331C67.9194 52.7937 65.6536 51.681 63.852 50.8392L62.4481 57.4088C64.2555 58.2419 67.6023 58.9683 71.073 59C79.2194 59 84.5494 54.9787 84.5782 48.7435C84.6099 40.8307 73.6328 40.3925 73.7077 36.8555C73.7337 35.7831 74.757 34.6387 76.9997 34.3476C78.1095 34.2006 81.1738 34.0882 84.6474 35.688L86.0109 29.3318C84.1429 28.6515 81.7417 28 78.7524 28C71.0845 28 65.6911 32.0761 65.6479 37.9105ZM99.1125 28.5477C97.6251 28.5477 96.3711 29.4154 95.8119 30.7472L84.1746 58.533H92.3152L93.9353 54.0563H103.883L104.823 58.533H111.998L105.737 28.5477H99.1125ZM100.251 36.6479L102.601 47.9076H96.1665L100.251 36.6479ZM55.7777 28.5477L49.3609 58.533H57.1181L63.532 28.5477H55.7777ZM44.3018 28.5477L36.2275 48.9569L32.9615 31.6033C32.5781 29.6662 31.0647 28.5477 29.3841 28.5477H16.1845L16 29.4183C18.7097 30.0063 21.7884 30.9547 23.6534 31.9694C24.795 32.5892 25.1207 33.1311 25.4954 34.6041L31.6816 58.533H39.8799L52.4482 28.5477H44.3018Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_3_3876",
			x1: 57.5,
			y1: 86,
			x2: 83.9498,
			y2: 1.87058,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#222357" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#254AA5"
			})]
		}) })
	]
});
export default SvgBillingVisa;
